<template>
	<span>{{getValue}}{{getAppend}}</span>
</template>
<script>
export default {
	name : "FloatSpan",
	props : {
		value : {
			default : ""
		},
		append : {
			default : ""
		},
		formatMoney : {
			type : Boolean,
			default : false
		},
	},
	computed : {
		getValue(){
			if(this.formatMoney){
				return parseFloat(this.value || 0).toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,');
				var number = this.value
				var decPlaces = 3;
				var decSep = ",";
				var thouSep = ".";
				var sign = number < 0 ? "-" : "";
				var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
				var j = (j = i.length) > 3 ? j % 3 : 0;

				return sign +
					(j ? i.substr(0, j) + thouSep : "") +
					i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
					(decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
			}
			return parseFloat( this.value ).toFixed(3)
		},
		getAppend(){
			return this.append == "" ? "" : " "+this.append
		}
	}
}
</script>

